import { motion } from "framer-motion";
import { Award } from "lucide-react";
import { BOOK } from "../lib/content";

export const AuthorBio = () => (
  <section id="autor" className="py-24 sm:py-32 lg:py-40" data-testid="author-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -60 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1 }}
          className="lg:col-span-5 relative"
        >
          <div className="absolute -inset-3 border border-[#C5A059]/25 translate-x-5 translate-y-5 pointer-events-none" />
          <div className="relative overflow-hidden group" data-testid="author-portrait-frame">
            <img
              src="/autor.jpg"
              alt="Edgar Merino Vidangossy en la final de la UEFA Women's Champions League"
              className="w-full aspect-[4/5] object-cover object-top grayscale group-hover:grayscale-0 transition-[filter] duration-700"
              data-testid="author-portrait"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0E]/70 via-transparent to-transparent" />
            <span className="absolute bottom-4 left-4 text-[10px] uppercase tracking-[0.25em] text-[#F2EFE9]/80">
              UEFA Women's Champions League · Final Oslo 26
            </span>
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, delay: 0.15 }}
          className="lg:col-span-7"
        >
          <span className="label-eyebrow">Sobre el autor</span>
          <h2 className="mt-6 font-display font-semibold uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight" data-testid="author-name">
            {BOOK.author.name}
          </h2>
          <span className="mt-3 block text-xs uppercase tracking-[0.25em] text-[#6E6C67]">{BOOK.author.role}</span>
          {BOOK.author.bio.map((p, i) => (
            <p key={i} className="mt-6 text-base sm:text-lg leading-relaxed text-[#A19F9A] font-light max-w-xl">
              {p}
            </p>
          ))}
          <blockquote className="mt-10 pl-6 border-l-2 border-[#C5A059] font-serif-book italic text-xl sm:text-2xl leading-snug text-[#E2C08D]/90 max-w-xl" data-testid="author-quote">
            «{BOOK.author.quote}»
          </blockquote>
          <ul className="mt-10 space-y-3">
            {BOOK.author.facts.map((f) => (
              <li key={f} className="flex items-start gap-3 text-sm text-[#A19F9A]">
                <Award size={14} className="text-[#C5A059] shrink-0 mt-0.5" />
                {f}
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
      <div className="mt-24 border-y border-white/8 py-12 grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12" data-testid="author-stats-panel">
        {BOOK.author.stats.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: i * 0.12 }}
            className="text-center"
            data-testid={`author-stat-${i}`}
          >
            <span className="font-display font-bold text-4xl sm:text-5xl text-gold block">{s.value}</span>
            <span className="mt-2 block text-xs uppercase tracking-[0.2em] text-[#A19F9A]">{s.label}</span>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
